import {
  InterventionReport,
  InterventionCompletionStatus,
  ReviewStatus,
} from '@inplay/models';
import { DateRange } from 'react-day-picker';
import { Dayjs } from 'dayjs';
import { ReactNode } from 'react';
import { InterventionReportModel } from '../../models/interventionReportModel';

export type InterventionReportProps = {};
export type InterventionReportsTableHeaderProps = {
  selectedCount: number;
  searchQuery: string;
  handleOnChangeSearch: (query: string) => void;
  selectedDateRange: DateRange | undefined;
  handleDateRangeChange?: (range: DateRange) => void;
  handleReportInterventionClick?: () => void;
  onSettingMenuSelect?: (label: string | undefined) => void;
  disableSettingMenu?: boolean;
  children?: ReactNode;
  reportLabel?: string;
  handleClose?: () => void;
  handleDelete?: () => void;
  handleDownload?: () => void;
  showDownloadLoading?: boolean;
};

export type InterventionReportsTableFilterProps = {
  selectedBranchIDs: string[];
  isOpenUserModal: boolean;
  hasActiveFilters: boolean;
  handleClearFilters: () => void;
  handleApplyFilters: (
    filters: InterventionReportAdvancedFilters,
    newDateRange?: DateRange,
  ) => void;
  toggleFilterModal: (value: boolean) => void;
  currentDateRange: DateRange;
  currentFilters: InterventionReportAdvancedFilters;
  reports?: InterventionReportModel[];
};

export enum InterventionReportsTableHeader {
  REPORT_NO = 'Report No.',
  NO = 'No.',
  CREATED_ON = 'Created on',
  PLAYER_NO = 'Player Id',
  HARM_OBSERVED = 'Harm Observed',
  FOLLOW_UP_ACTIONS = 'Follow-up Actions',
  TOTAL_INTERVENTIONS = 'Total Interventions',
  CREATED_BY = 'Created By',
  REVIEWED_BY = 'Reviewed By',
  ACTIONS = 'Actions',
  STATUS = 'Intervention Status',
}

export enum InterventionReportsKebabOption {
  VIEW = 'View',
  EDIT = 'Edit',
  REVIEW_AND_SIGN = 'Review & Sign',
  DOWNLOAD = 'Download',
  HISTORY = 'History',
  DELETE = 'Delete',
}

export enum InterventionReportsPendingAction {
  CREATE_INTERVENTION_REPORT = 'CREATE_INTERVENTION_REPORT',
  DELETE_REPORTS = 'DELETE_REPORTS',
  EDIT_REPORT = 'EDIT_REPORT',
  DOWNLOAD_REPORTS = 'DOWNLOAD_REPORTS',
}

export type InterventionReportsFilter = {
  searchQuery: string;
  selectedDateRange: DateRange;
  timeCreatedFrom?: Dayjs | null;
  timeCreatedUntil?: Dayjs | null;
  playerNo?: string;
  gender?: string;
  age?: string;
  ethnicity?: string;
  interventionStatus?: InterventionCompletionStatus[];
  harmInstances?: string;
  harmObserved?: string[];
  actionTaken?: string[];
  totalInterventionsOffered?: string;
  totalInterventionsRequested?: string;
  createdBy?: string;
  reviewedBy?: string;
  dateReviewedFrom?: Date;
  dateReviewedTo?: Date;
  reviewStatus?: ReviewStatus[];
  compliance?: string;
  followUpActions?: string[];
};

export type InterventionReportAdvancedFilters = Omit<
  InterventionReportsFilter,
  'searchQuery' | 'selectedDateRange'
>;

export type GetInterventionReportsResponse = {
  statusCode: number;
  status: string;
  message: string;
  data: {
    reports: InterventionReport[];
  };
};

export type InterventionReportDetailsProps = {
  interventionReport: InterventionReportModel;
  onClose: () => void;
  onReviewAndSign?: () => void;
  onKebabAction?: (action: string) => void;
  downloadLoading?: boolean;
};
